
import React from 'react';
import { compose, withState, defaultProps } from 'recompose';
import styled from 'styled-components';
import { hot } from 'react-hot-loader';
import { Form, Modal, Header, Button, Menu, Message, Input } from 'semantic-ui-react';
import { withLocale } from 'op/components/locale';
import { withSettingsModel } from './changePassword-modal.helper';
import { withOnlineStatus } from 'op/components/offline';

const ActionContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;	
`;

const WideSubmit = styled(Button)`
	width: 100%;
	background-color: ${props => props.theme.light} !important;
	color: ${props => props.theme.dark} !important;
`;

const PasswordInput = styled(Input)`	
	input {
	text-align: ${props => props.direction || 'left'}!important
	}
`;

const ChangePasswordModal = ({ trigger, openModal, setOpenModal, locale, confirmPassword, setConfirmPassword, oldPassword, setOldPassword, newPassword, setNewPassword, change, loading, error,success,reset }) => {
	/* const [check, setChecked] = useState(true)

	const onChangeHandler = (e, { checked }) => {
		setChecked(!checked)
	} */
	
	return (
		<Modal closeIcon
			style={{ direction: locale._meta.rtl ? 'rtl' : 'ltr' }}
			open={openModal}
			trigger={trigger(() => setOpenModal(true))}
			onClose={() => {
				//setOpenModal(false);
				reset();
			}}>
			<Header icon='key' content={locale.title} />
			<Modal.Content>
				{success?
				<Message 
				style={{ 'text-align': locale._meta.rtl ?'right' : 'left' }}
				content={locale.success}
			/>
				:
				<Form onSubmit={change} loading={loading} error={!!error} >
					<Form.Input >
						<PasswordInput direction={locale._meta.rtl ? 'right' : 'left'} placeholder={locale.oldPassword} type='password' value={oldPassword} onChange={(e) => setOldPassword(e.target.value)} />
					</Form.Input>
					<Form.Input >
						<PasswordInput direction={locale._meta.rtl ? 'right' : 'left'} placeholder={locale.newPassword} type='password' value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
					</Form.Input>
					<Form.Input >
						<PasswordInput direction={locale._meta.rtl ? 'right' : 'left'} placeholder={locale.confirmNewPassword} type='password' value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
					</Form.Input>
					<Message
						style={{ 'text-align': locale._meta.rtl ?'right' : 'left' }}
						error
						header={locale.error.header}
						content={locale.error.content}
					/>
				<WideSubmit type='submit' >{locale.submit} </WideSubmit>
				
					



					
				</Form>
}
			</Modal.Content>
		</Modal>);
};

export default compose(
	withSettingsModel,
	withOnlineStatus,
	withLocale('changePassword'),
	hot(module),
)(ChangePasswordModal);
